// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Plus Jakarta Sans', 'Plus Jakarta Sans Fallback'","fontStyle":"normal"},"className":"__className_9adad5"};